import React, {Component} from 'react';
import FJAddTextArea from './textEditor/FJAddTextArea';
import styles from './FJTextEditorModal.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import FJUtil from "../../../util/FJUtil";
import pressEnter from '../../../icon/press enter.svg';
import InlineSVG from "react-inlinesvg";
import FJButtonSemicircle from "../../../common/component/button-semicircle/FJButtonSemicircle";

class FJTextEditorModal extends Component {
    constructor(props) {
        super(props);
        this._inputElements = [];
    }

    componentDidMount() {
        this.callback();
    }

    _getInputs = () => {
        let comps = [];
        this._inputElements = [];
        for (let i = 0; i < this.props.maxContent; i++) {
            let ref = 'input' + i;
            this._inputElements.push(ref);
            comps.push(<FJAddTextArea key={ref} ref={(ele) => {this[ref] = ele}}
                                      placeholder={FJLocalStore._('input-place-holder')} />);
        }
        return comps;
    };

    callback = () => {
        this._updateText();
        setTimeout(() => {
            this._focus(this.props.focusIndex);
        });
    };

  _focus = (focusIndex) => {
        let editText = this[this._inputElements[focusIndex]] || this[this._inputElements[0]];
        if (editText) {
            editText.focus();
        }
    };

    _updateText = () => {
        let textData = this.props.textData;
        this._inputElements.forEach((item, index) => {
            if(textData[index]) {
                this[item].value(textData[index]);
            }
        });
    };

    _submit = () => {
        let textData = [];
        this._inputElements.forEach((item) => {
            let text = this[item].value();
            textData.push(text.map(str => FJUtil.filterStr(str)));
        });
      this.props.textContentChangeAction(textData);
    };


    render() {
        let {
            onCancel
        } = this.props;
        return (
            <div className={styles.box}>
                <div className={styles.title}>{FJLocalStore._('input-text')}</div>
                <div>
                    {this._getInputs()}
                </div>
                <div className={styles.footer}>
                    <div className={styles.footer_left}>
                        <InlineSVG src={pressEnter} />
                        <div className={styles.desc}>
                            {FJLocalStore._('press-enter-to-add-line')}
                        </div>
                    </div>
                    <div>
                        <FJButtonSemicircle size='large' className={styles.cancel} type='cancel' onClick={onCancel} text={FJLocalStore._('cancel')} />
                        <FJButtonSemicircle size='large' className={styles.done} onClick={this._submit} text={FJLocalStore._('done')}  />
                    </div>
                </div>
            </div>
        );
    }
}

export default FJTextEditorModal;
